module.exports = __webpack_public_path__ + "img/icon.7c230fa3.png";